<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text *ngIf="isLoaded" fxFlex="100" [allowHtml]="true" [mainText]="ChartSubtitle"
                           class="forge-typography--subheading1">
            </truncate-text>
        </div>

        <div slot="end" class="total">
            <span class="forge-typography--heading2">Ordered total:</span> {{total}}
        </div>
    </forge-toolbar>

    <div class="metadata-padding">
        <div *ngIf="isLoaded" fxLayout="row">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>
            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </div>
</forge-card>
